import React, { useRef } from 'react';
import html2pdf from 'html2pdf.js';
import { ArrowLeft, Download } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'react-loading-skeleton/dist/skeleton.css';

export default function InvoicePage() {
    const location = useLocation();
    const navigate = useNavigate();
    const invoiceRef = useRef(null);
    const invoiceData = location.state.invoice;

    const downloadPDF = () => {
        if (!invoiceRef.current || !invoiceData) return;

        const options = {
            filename: `${invoiceData?.stripe_invoice_id || 'invoice'}.pdf`,
            margin: 0.5,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
        };

        html2pdf().set(options).from(invoiceRef.current).save();
    };

    return (
        <div>
            <button
                onClick={() => navigate(-1)}
                className="flex items-center text-gray-600 text-base mb-4 mt-3 hover:text-gray-800"
            >
                <ArrowLeft className="w-4 h-4 mr-1" />
                Go back
            </button>

            <div className="max-w-4xl md:p-6 p-4 bg-white rounded-lg">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                    <div>
                        <h2 className="text-xl font-semibold text-gray-800">INVOICE</h2>
                        <p className="text-gray-500 text-sm">Payment receipt</p>
                    </div>
                        <button
                            onClick={downloadPDF}
                            className="flex items-center bg-[#212121] text-white text-sm px-4 py-3 rounded-xl transition w-full sm:w-auto justify-center"
                        >
                            <Download className="mr-2" size={18} />
                            Download PDF
                        </button>
                </div>

                <div ref={invoiceRef} className="p-6 border border-gray-200 rounded-xl">
                    <div className="flex flex-col sm:flex-row justify-between mb-6 gap-4">
                        <div>
                            <h3 className="text-sm font-medium text-gray-500 mb-1">INVOICE NO</h3>
                            <p className="text-base font-semibold text-gray-800">
                                {invoiceData?.stripe_invoice_id}
                            </p>
                        </div>
                        <div className="text-left sm:text-right">
                            <h3 className="text-sm font-medium text-gray-500 mb-1">DATE</h3>
                            <p className="text-base font-semibold text-gray-800">
                                {moment(invoiceData?.current_period_start).format('MM/DD/YYYY')}
                            </p>
                        </div>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-sm font-semibold text-gray-700 mb-2 border-b pb-1">Details:</h3>
                        <p className="text-sm text-gray-600 leading-relaxed">
                            {invoiceData?.plan_name || "-"}
                        </p>
                    </div>

                    <div className="bg-[#F8FAFB] p-4 rounded w-full">
                        <h3 className="text-sm font-medium text-gray-500 mb-1">TOTAL AMOUNT</h3>
                        <p className="text-xl font-semibold">
                            {`$${invoiceData?.amount}`}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
